<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Jenis Barang</h5>    
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA UMUM</h6>
                    <b-form-group label="Nama Jenis Barang">
                        <b-form-input v-model="input.jenisBarang" name="jenisBarang" ref="jenisBarang" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Tipe Pinjaman">
                        <b-form-select v-model="input.tipePinjaman" name="tipePinjaman" :options="tipePinjaman" value-field="id" text-field="name" disabled>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group>
                        <label>Panduan Nama Tipe</label>
                        <b-input-group class="mb-3">
                            <b-form-input v-model="input.panduanNamaTipe" name="panduanNamaTipe" maxlength="255" ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper">
                    <label>Surat Edaran Jenis Barang</label>
                    <b-row>
                        <b-col cols="10" md="3">
                         
                                <FormulateForm v-model="pdf">
                                    <FormulateInput v-if="url.length != 0"
                                    ref="urlPDF"
                                    name="urlPDF"
                                    type="file"
                                    :value="url"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
               
                                </FormulateForm>

                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of pdf.urlPDF.files">
                                <span v-if="url != null">
                                    <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">KELENGKAPAN BARANG</h6>
                    <label>Surat Edaran Kelengkapan Barang</label>
                    <b-row>
                        <b-col cols="10" md="3">
                                <FormulateForm v-model="pdf1">
                                    <FormulateInput v-if="url1.length != 0"
                                    ref="urlPDF"
                                    name="urlPDF"
                                    type="file"
                                    :value="url1"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
               
                                </FormulateForm>

                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of pdf1.urlPDF.files">
                                <span v-if="url1 != null">
                                    <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-tabs class="tab-wrapper" content-class="tab-content-wrapper">
                        <b-tab title="Aktif">
                            <div>
                                <b-button variant="pgiBtn" class="mb-2" @click="addKelengkapan" name="kelengkapanAddBtn"><i class="fa fa-plus mr-2"></i>Kelengkapan</b-button>
                                <Kelengkapan v-for="item in input.kelengkapan" v-bind:key="item.index"
                                    :kelengkapan="item" :length="input.kelengkapan.length" @remove="removeKelengkapan(item.index, item.id)"
                                    @nonAktif="nonAktifKelengkapan(item.index, item.id, item.name)"
                                    :filePDF = "item.filePDF" 
                                    @changeSEKelengkapan="changeSEKelengkapan"
                                    @openModalPreviewPDFSpekKel="openModalPreviewPDFSpekKel"
                                    @removeSEKel = "removeSEKel"
                                />
                            </div>
                        </b-tab>
                        <b-tab title="Non Aktif">
                            <KelengkapanNonAktif v-for="item in nonAktifKelengkapanJenis" v-bind:key="item.index"
                                :kelengkapan="item" :length="input.kelengkapan.length"
                                @aktif="aktifKelengkapan(item.index, item.id, item.name)"
                            />
                        </b-tab>
                    </b-tabs>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">SPESIFIKASI</h6>
                    <b-tabs class="tab-wrapper" content-class="tab-content-wrapper">
                        <b-tab title="Aktif">
                            <div>
                                <b-button variant="pgiBtn" class="mb-2" @click="addSpesifikasi" name="spesifikasiAddBtn"><i class="fa fa-plus mr-2"></i>Spesifikasi</b-button>
                                <Spesifikasi :isEditJenis="isEditJenis" v-for="item in input.spesifikasi" 
                                v-bind:key="item.index" 
                                v-bind:id="item.id"
                                 :idSpesifikasi="item.id" 
                                 @removeFoto="removeFoto" 
                                 :fotoPendukung="item.fotoPendukung" 
                                 :spesifikasi="item" :length="input.spesifikasi.length" 
                                 @remove="removeSpesifikasi(item.index, item.id)" 
                                 @showModalCam="openModalCam"
                                 @showModalPreview="openModalPreview"
                                 @nonAktif="nonAktifSpesifikasi(item.index, item.id, item.detailInfo, item.name, item.nominalAngka, item.nominalPersen)"
                                 :filePDF = "item.filePDF"
                                 @changeSESpek="changeSESpek"
                                 @openModalPreviewPDFSpekKel = "openModalPreviewPDFSpekKel"
                                 @removeSESpek = "removeSESpek"
                                />
                            </div>
                        </b-tab>
                        <b-tab title="Non Aktif">
                            <SpesifikasiNonAktif v-for="item in nonAktifSpesifikasiJenis" v-bind:key="item.index"
                                    :spesifikasi="item" :length="input.spesifikasi.length" @aktif="aktifSpesifikasi(item.index, item.id, item.detailInfo, item.name, item.nominalAngka, item.nominalPersen)"
                                />
                        </b-tab>
                    </b-tabs>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="jenisBarangUpdatebtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Jenis Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah jenis barang ini?" @submit="onSubmit" />
        <ModalConfirm id="modal-confirm-hapus-spesifikasi" title="Confirm Hapus Spesifikasi"  desc="Apakah anda yakin untuk menghapus spesifikasi barang ini?" @submit="onSubmitHapusSpesifikasi" />
        <ModalConfirm id="modal-confirm-hapus-kelengkapan" title="Confirm Hapus Kelengkapan"  desc="Apakah anda yakin untuk menghapus kelengkapan barang ini?" @submit="onSubmitHapusKelengkapan" />

        <ModalConfirm id="modal-confirm-non-aktif-spesifikasi" title="Confirm Non Aktif Spesifikasi"  desc="Apakah anda yakin untuk menonaktifkan spesifikasi barang ini?" @submit="onSubmitNonAktifSpesifikasi" />
        <ModalConfirm id="modal-confirm-aktif-spesifikasi" title="Confirm Aktif Spesifikasi"  desc="Apakah anda yakin untuk mengaktifkan spesifikasi barang ini?" @submit="onSubmitAktifSpesifikasi" />

        <ModalConfirm id="modal-confirm-non-aktif-kelengkapan" title="Confirm Non Aktif Spesifikasi"  desc="Apakah anda yakin untuk menonaktifkan spesifikasi barang ini?" @submit="onSubmitNonAktifKelengkapan" />
        <ModalConfirm id="modal-confirm-aktif-kelengkapan" title="Confirm Aktif Spesifikasi"  desc="Apakah anda yakin untuk mengaktifkan spesifikasi barang ini?" @submit="onSubmitAktifKelengkapan" />

        <ModalConfirm  id="modal-hapus" title="Confirm Hapus Foto" desc="Foto Akan Terhapus Permanen" @submit=removeFotoPendukung />
        <ModalConfirm  id="modal-hapus-se" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSE />
        <ModalConfirm  id="modal-hapus-se-spek" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=confirmRemoveSESpek />
        <ModalConfirm  id="modal-hapus-se-kel" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSEKel />

        <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
        <ModalWebCam idWebcam="webcam-input-elek" @photoTaken="setResult"  />

         <!-- MODAL SHOW SE -->
         <b-modal id="modal-SE" size="lg" title="Modal SE">
                <iframe width="100%" height="700" allowfullscreen :src="activePdfPreview" frameborder="0"></iframe>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
            </b-modal>
            
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
import { async } from 'q';
import Kelengkapan from '../../../components/kelengkapan/Kelengkapan';
import KelengkapanNonAktif from '../../../components/kelengkapan/KelengkapanNonAktif';
import Spesifikasi from '../../../components/spesifikasi/Spesifikasi';
import SpesifikasiNonAktif from '../../../components/spesifikasi/SpesifikasiNonAktif';

import ModalPreview from '../../../components/webcam/ModalPreview.vue';
import ModalWebCam from '../../../components/webcam/ModalWebCam.vue'

export default {
    name: 'edit-jenis-barang',
    components: { 
        Kelengkapan, 
        Spesifikasi, 
        SpesifikasiNonAktif, 
        KelengkapanNonAktif,
        ModalPreview,
        ModalWebCam
    },
    data(){
        return{
            foto : [],
            isEditJenis: true,
            id: null,
            initStatus: 0,
            isSubmitting: false,
            input:{
                jenisBarang: "",
                tipePinjaman: null,
                kelengkapan: [
                ],
                spesifikasi: [
                ],
                filePDF: null,
                filePDFKelengkapan: null,
                panduanNamaTipe:""
            },
            pdf: {
                urlPDF : {
                    fileList:[]
                }
            },
            pdf1: {
                urlPDF : {
                    fileList:[]
                }
            },
            tipePinjaman: [],
            indexKelengkapan: 0,
            idSpesifikasi:0,
            indexSpesifikasi: 0,
            deleteKelengkapan: [],
            deleteSpesifikasi: [],
            nonAktifSpesifikasiJenis: [],
            nonAktifKelengkapanJenis:[],
            modalConfirmRemove: {},
            modalConfirmNonAktif: {},
            modalConfirmAktif: {},

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungId: null,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",
            isCreate: true,
            activePdfPreview: null,
            
            
            confirmDelId:null,
            confirmDelIndex:null,
            confirmDelIdSpesifikasi:null,

            url : [],
            url1 : [],

            pdfRecords:[],
            pdfNewVal:[],

            pdfRecords1:[],
            pdfNewVal1:[],

            hapusSE:[],

            idSpek:null,
            pdfRecordsSpek:[],
            pdfNewValSpek:[],

            idKel:null,
        }
    }, 
    
    methods:{
 
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getTipePinjaman = this.$axios.get("jenis-pinjaman/").then(response => {
                this.tipePinjaman = response.data
            })
            
            let getSingleJenisBarang = this.$axios.get(`barang-jenis/${this.id}`).then(response => {      
                this.jenisBarang = response.data
                //----------------- Inisialisasi Data Jenis Barang -----------------

                if(this.jenisBarang.suratEdaran.length != 0){
                    for(var file of this.jenisBarang.suratEdaran){
                        this.url.push({
                            id: file.id,
                            url:file.filepath,
                        })
                    }
                }
               
                this.input.jenisBarang = this.jenisBarang.name
                this.input.panduanNamaTipe = this.jenisBarang.panduanNamaTipe
                this.input.tipePinjaman = this.jenisBarang.jenisPinjaman.id
                for (var x of this.jenisBarang.kelengkapan) {
                    if(x.isActive == true){
                        let urlpdf = []
                        for(var file of x.suratEdaran){
                            urlpdf.push({
                                id: file.id,
                                url:file.filepath
                            })
                        }

                        this.input.kelengkapan.push({
                            index: this.indexKelengkapan,
                            id: x.id,
                            name: x.name,
                            // url : urlpdf,
                            // filePDF : []
                        })
                    }else{
                        if(x.isActive == false){
                            this.nonAktifKelengkapanJenis.push({
                                index: this.indexKelengkapan,
                                id: x.id,
                                name: x.name
                            })
                        }
                    }
                    this.indexKelengkapan++
                }
              
                let nameSpec, detailInfoSpec, nominalPSpec, nominalASpec, nominalAngka = null
                for (var x of this.jenisBarang.spesifikasi) {
                    
                    nameSpec = x.name
                    let nominalPSpec, nominalASpec, nominalAngka = null

                    if (x.nominalAngka == null) {
                        detailInfoSpec = "persen",
                        nominalPSpec = x.nominalPersen                            
                    } 
                    else {
                        nominalAngka = this.$helper.addThousandSeparator(x.nominalAngka);
                        detailInfoSpec = "nominal",
                        nominalASpec = nominalAngka
                    }
                  
                    let fotoSpek =[]
                    let index = 0
                    for(var f of x.fotoSpesifikasi){
                        fotoSpek.push({
                            index: index,
                            id: f.id,
                            name : f.name,
                            checkFotoBarangPendukung : true,
                            fotoBarangPendukungPlaceholder: f.name,
                            fotoBarangPendukung: null,
                            fotoBarangPendukungBase64: null,
                            activeFotoPendukungBase64: null,
                            isChangeFoto: false,
                            hidden: false,
                        })
                        index++
                    }

                    if(x.isActive == true){
                       
                        let url = []

                            for(var file of x.suratEdaran){
                                url.push({
                                    id: file.id,
                                    url:file.filepath
                                })
                            }

                            this.input.spesifikasi.push({
                            index: this.indexSpesifikasi,
                            id: x.id,
                            name: nameSpec,
                            detailInfo: detailInfoSpec,
                            nominalPersen: nominalPSpec,
                            nominalAngka: nominalASpec,
                                
                            fotoPendukung: fotoSpek,

                            indexFotoPendukung: 1,
                            fotoPendukungError: false,
                            activeFotoPendukungIndex: null,
                            activeFotoPreviewIndex: null,
                            minLengthFotoPendukung: 1,
                            activeFotoPreview: "",
                            filePDF: [],
                            url:url
                                    
                       })
                         
                      
                          
                    }else if(x.isActive == false){
                       this.nonAktifSpesifikasiJenis.push({
                            index: this.indexSpesifikasi,
                            id: x.id,
                            name: nameSpec,
                            detailInfo: detailInfoSpec,
                            nominalPersen: nominalPSpec,
                            nominalAngka: nominalASpec,

                            fotoPendukung: fotoSpek,

                            indexFotoPendukung: 1,
                            fotoPendukungError: false,
                            activeFotoPendukungIndex: null,
                            activeFotoPreviewIndex: null,
                            minLengthFotoPendukung: 1,
                            activeFotoPreview: "",
                        })
                    }
                    this.indexSpesifikasi++
 
                }
                
            })

            let getSeKelengkapan = this.$axios.get("surat-edaran/list/?menu=kelengkapan"+this.$route.params.id+"&jenis=kelengkapan").then(response => {
            for(var file of response.data){
                    this.url1.push({
                        id: file.id,
                        url:file.filepath,
                    })
                }
            })

       

            Promise.all([getTipePinjaman, getSingleJenisBarang , getSeKelengkapan]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
    
        openModalPreview(idSpekFotoModPrev,idFotoModPrev,indexModPrev,name){

            let id = this.input.spesifikasi.findIndex(item => item.id == idSpekFotoModPrev)
            let index = this.input.spesifikasi[id].fotoPendukung.findIndex(item => item.index == indexModPrev)
            if(name != null){
                this.activeFotoPreview = this.$baseFilePath + this.input.spesifikasi[id].fotoPendukung[index].name
            }else{
                this.activeFotoPreview =  this.input.spesifikasi[id].fotoPendukung[index].activeFotoPendukungBase64 
            }
 
            this.$bvModal.show("modal-preview-gadai")
        },
        
        openModalCam(id,index){
            this.activeFotoPendukungId = id
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
                let id = this.input.spesifikasi.findIndex(item => item.id ==  this.activeFotoPendukungId)
           
                let index = this.input.spesifikasi[id].fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex)
    
                this.input.spesifikasi[id].fotoPendukung[index].fotoBarangPendukungBase64 = newResult
                this.input.spesifikasi[id].fotoPendukung[index].activeFotoPendukungBase64 = newResult
                this.input.spesifikasi[id].fotoPendukung[index].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
                this.input.spesifikasi[id].fotoPendukung[index].checkFotoBarangPendukung = true
        },

        removeFoto(id , index ,idSpesifikasi){
            if(idSpesifikasi!=null){
                this.confirmDelId = id
                this.confirmDelIndex = index
                this.confirmDelIdSpesifikasi=idSpesifikasi
            }
            else{
                this.confirmDelId = id
                this.confirmDelIndex = index
            }

            this.$bvModal.show("modal-hapus")
        },

        removeFotoPendukung() {
            if(this.confirmDelIdSpesifikasi!=null){
               let spesifikasi = this.input.spesifikasi.filter(item => item.id == this.confirmDelIdSpesifikasi)[0]
               for(var fotoPendukung of spesifikasi.fotoPendukung){
                if(fotoPendukung.name == this.confirmDelIndex ){
                    fotoPendukung.hidden = true
                }
                }   
            }else{
                let spesifikasi = this.input.spesifikasi.filter(item => item.id == this.confirmDelId)[0]
                let fotoPendukung = spesifikasi.fotoPendukung.filter(item => item.index != this.confirmDelIndex)
                let id = this.input.spesifikasi.findIndex(item => item.id == this.confirmDelId);
                this.input.spesifikasi[id].fotoPendukung = fotoPendukung
            }

            this.confirmDelId = null
            this.confirmDelIndex = null
            this.confirmDelIdSpesifikasi = null

            this.fotoPendukungError = false;
            this.$bvModal.hide("modal-hapus")
        },

        //----------------- Fungsi Tambah Hapus Data Kelengkapan & Spesifikasi -----------------
        
        addKelengkapan() {
            this.input.kelengkapan.unshift({ 
                index: this.indexKelengkapan, 
                id: 0, 
                data: "",
            })
            this.indexKelengkapan++
        },

        removeKelengkapan(index, id) {
            this.$bvModal.show("modal-confirm-hapus-kelengkapan")
            this.modalConfirmRemove = {
                index: index,
                id: id
            }
        },

        onSubmitHapusKelengkapan() {
            this.$bvModal.hide("modal-confirm-hapus-kelengkapan")
            this.input.kelengkapan = this.input.kelengkapan.filter(item => item.index != this.modalConfirmRemove.index)
            if(this.modalConfirmRemove.id != 0){
                this.deleteKelengkapan.push(this.modalConfirmRemove.id)
            }
        },

        addSpesifikasi() {
            this.input.spesifikasi.unshift({ 
                index: this.indexSpesifikasi, 
                id: this.idSpesifikasi, 
                isNewSpek: true,
                name: "", 
                detailInfo: "persen", 
                nominalPersen: null, 
                nominalAngka: null,
                fotoPendukung:[ ],
                filePDF: [],
                url : []
             })
        
            this.indexSpesifikasi++
            this.idSpesifikasi++
        },

        removeSpesifikasi(index, id) {
            this.$bvModal.show("modal-confirm-hapus-spesifikasi")
            this.modalConfirmRemove = {
                index: index,
                id: id
            }
        },

        onSubmitHapusSpesifikasi() {
            this.$bvModal.hide("modal-confirm-hapus-spesifikasi")
            this.input.spesifikasi = this.input.spesifikasi.filter(item => item.index != this.modalConfirmRemove.index)
            if(this.modalConfirmRemove.id != 0){
                this.deleteSpesifikasi.push(this.modalConfirmRemove.id)
            }
        },
            
          
        toBase64(file) {
            
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },


        //----------------- Fungsi aktif & non aktif Spesifikasi ------------------------
        nonAktifSpesifikasi(index, id, detailInfo, name, nominalAngka, nominalPersen) {
            this.$bvModal.show("modal-confirm-non-aktif-spesifikasi")
            this.modalConfirmNonAktif = {
                index: index,
                id: id,
                detailInfo: detailInfo,
                name: name,
                nominalAngka: nominalAngka,
                nominalPersen: nominalPersen
            }
        },

        onSubmitNonAktifSpesifikasi() {
            let payloadNonAktif = new FormData()
            payloadNonAktif.append("SpekId", this.modalConfirmNonAktif.id)
            payloadNonAktif.append("isActive", false)
            this.$axios.post("/barang-jenis/spesifikasi/switch-is-active", payloadNonAktif).then(response => {
                location.reload()
                // this.$helper.setFlash(`Tipe barang telah berhasil di nonaktifkan!`)
                // let path = this.$route.path.split("/")
                // path.pop()
                // path = path.join("/")
                // this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })

            this.$bvModal.hide("modal-confirm-non-aktif-spesifikasi")
        },


        aktifSpesifikasi(index, id, detailInfo, name, nominalAngka, nominalPersen) {
            this.$bvModal.show("modal-confirm-aktif-spesifikasi")
            this.modalConfirmAktif = {
                index: index,
                id: id,
                detailInfo: detailInfo,
                name: name,
                nominalAngka: nominalAngka,
                nominalPersen: nominalPersen
            }
        },

        onSubmitAktifSpesifikasi() {
            let payloadAktif = new FormData()
            payloadAktif.append("SpekId", this.modalConfirmAktif.id)
            payloadAktif.append("isActive", true)
                this.$axios.post("/barang-jenis/spesifikasi/switch-is-active", payloadAktif).then(response => {
                    location.reload()
                    // this.$helper.setFlash(`Tipe barang telah berhasil di nonaktifkan!`)
                    // let path = this.$route.path.split("/")
                    // path.pop()
                    // path = path.join("/")
                    // this.$router.push({ path })
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            this.$bvModal.hide("modal-confirm-aktif-spesifikasi")
        },

        //----------------- Fungsi aktif & non aktif Kelengkapan Barang ------------------------
        nonAktifKelengkapan(index, id, name) {
            this.$bvModal.show("modal-confirm-non-aktif-kelengkapan")
            this.modalConfirmNonAktif = {
                index: index,
                id: id,
                name: name,
            }
        },

        onSubmitNonAktifKelengkapan() {
            let payloadNonAktif = new FormData()
            payloadNonAktif.append("id", this.modalConfirmNonAktif.id)
            payloadNonAktif.append("isActive", false)
            this.$axios.post("/barang-jenis/kelengkapan/switch-is-active", payloadNonAktif).then(response => {
                location.reload()
                // this.$helper.setFlash(`Tipe barang telah berhasil di nonaktifkan!`)
                // let path = this.$route.path.split("/")
                // path.pop()
                // path = path.join("/")
                // this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            this.$bvModal.hide("modal-confirm-non-aktif-kelengkapan")
        },

        aktifKelengkapan(index, id, name) {
            this.$bvModal.show("modal-confirm-aktif-kelengkapan")
                this.modalConfirmAktif = {
                    index: index,
                    id: id,
                    name: name,
                }
        },

        onSubmitAktifKelengkapan() {
            let payloadAktif = new FormData()
            payloadAktif.append("id", this.modalConfirmAktif.id)
            payloadAktif.append("isActive", true)
            this.$axios.post("/barang-jenis/kelengkapan/switch-is-active", payloadAktif).then(response => {
                location.reload()
                // this.$helper.setFlash(`Tipe barang telah berhasil di aktifkan!`)
                // let path = this.$route.path.split("/")
                // path.pop()
                // path = path.join("/")
                // this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })

            this.$bvModal.hide("modal-confirm-aktif-kelengkapan")
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            let payload = new FormData()

            //----------------- Append Data Jenis Barang -----------------
            if (this.input.kelengkapan.length != 0) {
                for (var x of this.input.kelengkapan) {
                    payload.append("kelengkapanId", x.id)
                    payload.append("kelengkapanName", x.name)
                }
            }

             //File PDF
            
             if( this.input.filePDF != null){

                for(var file of this.input.filePDF ){
                    
                    if(file.size != null){
                        //untuk struktur form file baru
                        payload.append("pdfFiles" , file)
                    }
                    else if (file.file.size != null){
                         //untuk struktur form file Lama
                        payload.append("pdfFiles" , file.file)
                    }else {
                        //Jika tidak Update Kirim File Kosong
                        let metadata = {
                            type: 'application/pdf'
                        }
                        let fileInput = new File([],"pdf",metadata)
                        payload.append("pdfFiles" , fileInput)
                    }
                }
            }

             //Kelengkapan PDF
            
             if( this.input.filePDFKelengkapan != null){

                let payloadKelengkapan = new FormData()
                payloadKelengkapan.append("menu" , "kelengkapan"+this.id)
                payloadKelengkapan.append("jenis" , "kelengkapan")
                payload.append("suratKelengkapan" , "kelengkapan"+this.id)

                for(var file of this.input.filePDFKelengkapan ){
                    
                    if(file.size != null){
                        //untuk struktur form file baru
                   
                        payloadKelengkapan.append("pdfFiles" , file)
                    }
                    else if (file.file.size != null){
                         //untuk struktur form file Lama
                      
                         payloadKelengkapan.append("pdfFiles" , file.file)       
                    }
                    else {
                        //Jika tidak Update Kirim File Kosong
                        let metadata = {
                            type: 'application/pdf'
                        }
                        let fileInput = new File([],"pdf",metadata)
                        payloadKelengkapan.append("pdfFiles" , fileInput)
                    }
                }

                this.$axios.post("surat-edaran/insertOrUpdate/",payloadKelengkapan).then(response => {
                        })
                        .catch(error => {
                            console.log(error)
                            console.log(error.response.data.reason)
                            this.$helper.parseError(this, error)
                        })
                        .finally(() => {
                            
                        })
            }

            // 1 Spek
            if (this.input.spesifikasi.length == 1){
    
                for (var x of this.input.spesifikasi) {
              
                    let nominal = this.$helper.removeThousandSeparator(x.nominal);
                    if(x.isNewSpek == true){
                        payload.append("spesifikasiId", 0)
                    }else{
                        payload.append("spesifikasiId", x.id)
                    }
                    payload.append("spesifikasiName", x.name)
                    if (x.detailInfo == "nominal") {
                        let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                        payload.append('spesifikasiNominalAngka', nominalAngka)
                        payload.append('spesifikasiNominalPersen', null)
                    } 
                    else {
                        payload.append('spesifikasiNominalPersen', x.nominalPersen)
                        payload.append('spesifikasiNominalAngka', null)
                    }
                    if(x.fotoPendukung.length !=0){
                        let jsonFoto = []
                        let idFotoLama = []
                        for(var foto of x.fotoPendukung ){
                            if(foto.isNew == true && foto.activeFotoPendukungBase64 != null){
                                jsonFoto.push(foto.activeFotoPendukungBase64)
                            }
                            //jika foto di ubah
                            else if(foto.isChangeFoto == true && foto.activeFotoPendukungBase64 != null){
                                payload.append( "deleteSpesifikasiFotoId" , foto.id)
                                jsonFoto.push(foto.activeFotoPendukungBase64)
                            }
                            //jika hapus
                            else if( foto.hidden == true ){
                               payload.append( "deleteSpesifikasiFotoId" , foto.id)
                               idFotoLama.push(foto.id)
                  
                               jsonFoto.push( "" )
                            }

                            else if(foto.isChangeFoto == false){
                                jsonFoto.push(this.$baseFilePath + foto.name)
                            }
                        }
         
                        payload.append("spesifikasiFoto", JSON.stringify(jsonFoto)) 
                        //payload.append( "idFotoLama" , idFotoLama)
                        jsonFoto = []
                        idFotoLama = []
               
                                            
                    }
                    else if (x.fotoPendukung.length == 0){
                        //jika tidak ada foto tidak append array kosong 
                        payload.append("spesifikasiFoto",  JSON.stringify([])) 
                    }


                    payload.append("suratSpek" , "spesifikasi"+x.id)
                    if(x.filePDF != null){
                        if( x.filePDF.length != 0){

                            let payloadSpesifikasi = new FormData()
                            payloadSpesifikasi.append("menu" , "spesifikasi"+x.id)
                            payloadSpesifikasi.append("jenis" , "spesifikasi")
                           
        
                            for(var file of x.filePDF){
                            if(file.size != null){
                                payloadSpesifikasi.append("pdfFiles", file)   
                            }
                            else if(file.file.url == null){
                                payloadSpesifikasi.append("pdfFiles", file.file)                 
                            }
                            else {
                                //Jika tidak Update Kirim File Kosong
                                let metadata = {
                                    type: 'application/pdf'
                                }
                                let fileInput = new File([],"pdf",metadata)
                                payloadSpesifikasi.append("pdfFiles" , fileInput)
                                }
                            }
                        
                            this.$axios.post("surat-edaran/insertOrUpdate/",payloadSpesifikasi).then(response => {
                            })
                            .catch(error => {
                                console.log(error)
                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                       
                    }
                }
                // cheat abang adit
                payload.append("spesifikasiFoto" , "")

            }
            // Multi Spek
            else if (this.input.spesifikasi.length != 0) {
         
                for (var x of this.input.spesifikasi) {
                    

                    let nominal = this.$helper.removeThousandSeparator(x.nominal);
                    if(x.isNewSpek == true){
                        payload.append("spesifikasiId", 0)
                    }else{
                        payload.append("spesifikasiId", x.id)
                    }
                    payload.append("spesifikasiName", x.name)
                    if (x.detailInfo == "nominal") {
                        let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                        payload.append('spesifikasiNominalAngka', nominalAngka)
                        payload.append('spesifikasiNominalPersen', null)
                    } 
                    else {
                        payload.append('spesifikasiNominalPersen', x.nominalPersen)
                        payload.append('spesifikasiNominalAngka', null)
                    }
                    if(x.fotoPendukung.length !=0){
                        let jsonFoto = []
                        let idFotoLama = []
                        for(var foto of x.fotoPendukung ){
                            if(foto.isNew == true && foto.activeFotoPendukungBase64 != null){
                                jsonFoto.push(foto.activeFotoPendukungBase64)
                            }
                            //jika foto di ubah
                            else if(foto.isChangeFoto == true && foto.activeFotoPendukungBase64 != null){
                                payload.append( "deleteSpesifikasiFotoId" , foto.id)
                                jsonFoto.push(foto.activeFotoPendukungBase64)
                            }
                            //jika hapus
                            else if( foto.hidden == true ){
                               payload.append( "deleteSpesifikasiFotoId" , foto.id)
                               idFotoLama.push(foto.id)
                  
                               jsonFoto.push( "" )
                            }

                            else if(foto.isChangeFoto == false){
                                jsonFoto.push(this.$baseFilePath + foto.name)
                            }
                        }
             
                        payload.append("spesifikasiFoto", JSON.stringify(jsonFoto)) 
                        jsonFoto = []
                        idFotoLama = []
                                            
                    }
                    else if (x.fotoPendukung.length == 0){
                        //jika tidak ada foto tidak append array kosong 
                        payload.append("spesifikasiFoto",  JSON.stringify([])) 
                    }
                
                    payload.append("suratSpek" , "spesifikasi"+x.id)
                    if(x.filePDF != null){
                        if( x.filePDF.length != 0){

                            let payloadSpesifikasi = new FormData()
                            payloadSpesifikasi.append("menu" , "spesifikasi"+x.id)
                            payloadSpesifikasi.append("jenis" , "spesifikasi")
                           
                 


                            for(var file of x.filePDF){
                            if(file.size != null){
                                payloadSpesifikasi.append("pdfFiles", file)   
                            }
                            else if(file.file.url == null){
                                payloadSpesifikasi.append("pdfFiles", file.file)                 
                            }
                            else {
                                //Jika tidak Update Kirim File Kosong
                                let metadata = {
                                    type: 'application/pdf'
                                }
                                let fileInput = new File([],"pdf",metadata)
                                payloadSpesifikasi.append("pdfFiles" , fileInput)
                                }
                            }
                        
                            this.$axios.post("surat-edaran/insertOrUpdate/",payloadSpesifikasi).then(response => {
                            })
                            .catch(error => {
                                console.log(error)
                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                       
                    }
                 
                }
                // cheat abang adit
                // payload.append("spesifikasiFoto" , "")
            }
            

            if (this.deleteKelengkapan != []) {
                for (var x of this.deleteKelengkapan) {
                    payload.append("deleteKelengkapanId", x)
                }
            }

            if (this.deleteSpesifikasi != []) {
                for (var x of this.deleteSpesifikasi) {
                    payload.append("deleteSpesifikasiId", x)
                }
            }

            payload.append("id", this.id)
            payload.append("name", this.input.jenisBarang)
            payload.append("panduanNamaTipe", this.input.panduanNamaTipe)
            payload.append("jenisPinjamanId", this.input.tipePinjaman)

            //Hapus se jika ada
            if(this.hapusSE.length != 0){
                for(var id of this.hapusSE){
                        let payloadHapus = new FormData()
                        payloadHapus.append("id", id)
                        this.$axios.post("surat-edaran/delete/", payloadHapus)
                }    
            }
   
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            this.$axios.post("barang-jenis/", payload).then(response => {
                this.$helper.setFlash(`Jenis barang telah berhasil diubah!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if(this.input.filePDF != null) {
                for(var file of this.input.filePDF){
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }

            if(this.input.filePDFKelengkapan != null) {
                for(var file of this.input.filePDFKelengkapan){
                  
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }

            for( var spesifikasi of this.input.spesifikasi){
              
                if(spesifikasi.filePDF != null){
                for(var file of spesifikasi.filePDF){
                      
                       if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                        }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                    }
                }
            }


            this.$bvModal.show("modal-confirm-edit")
        },

          //----------------- Fungsi SE -----------------
          changeFilePDF(){
            this.toBase64(this.input.filePDF.files[0].file).then(async base64 => {   
            this.input.filePDF.base64 = base64
            //this.activePdfPreview = base64
            })

        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

        openModalPreviewPDF(pdf){
            if(pdf.size != null){  
                    this.toBase64(pdf).then(async base64 => {   
                    this.activePdfPreview = base64
                 })
                
            }

            this.activePdfPreview = pdf
            this.$bvModal.show("modal-SE")
        },

        //----------------- Fungsi SE Spesifikasi -----------------
        changeSESpek(idSpesifikasi,filePDF){
            let idx = this.input.spesifikasi.findIndex(item => item.id == idSpesifikasi)
            this.input.spesifikasi[idx].filePDF = filePDF
        },

        changeSEKelengkapan(index,filePDF){
            let idx = this.input.kelengkapan.findIndex(item => item.index == index)
            this.input.kelengkapan[idx].filePDF = filePDF
        },

        openModalPreviewPDFSpekKel(base64){
            this.activePdfPreview = base64
            this.$bvModal.show("modal-SE")
        },

        removeSE(){
 
            for(var file of this.pdf.urlPDF.files){
               let idx = this.pdfNewVal.findIndex(item => item.name == file.name)

               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }

            this.pdf.urlPDF.files = this.pdfNewVal
            this.pdfRecords = this.pdfNewVal
            this.$bvModal.hide("modal-hapus-se")
        },

        removeSEKel(){

            for(var file of this.pdf1.urlPDF.files){
               let idx = this.pdfNewVal1.findIndex(item => item.name == file.name)
               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }

            this.pdf1.urlPDF.files = this.pdfNewVal1
            this.pdfRecords1 = this.pdfNewVal1
            this.$bvModal.hide("modal-hapus-se-kel")
        },
        
        removeSESpek(idSpek,pdfRecords,newVal){
            this.idSpek = idSpek
            this.pdfRecordsSpek = pdfRecords
            this.pdfNewValSpek = newVal
            this.$bvModal.show("modal-hapus-se-spek")
        },
        confirmRemoveSEKel(){

            let idx = this.input.kelengkapan.findIndex(item => item.index == this.idKel)

            for(var file of  this.input.kelengkapan[idx].filePDF){
                let idxNewVAl = this.pdfNewValKel.findIndex(item => item.name == file.name)
                if(idxNewVAl == -1){
                    if(file.path.id != undefined){
                        this.hapusSE.push(file.path.id)
                    }
                }
            }

            this.input.kelengkapan[idx].filePDF = this.pdfNewValKel
             this.$bvModal.hide("modal-hapus-se-kel")
        },

        confirmRemoveSESpek(){
            let idx = this.input.spesifikasi.findIndex(item => item.id == this.idSpek)

            for(var file of  this.input.spesifikasi[idx].filePDF){
                let idxNewVAl = this.pdfNewValSpek.findIndex(item => item.name == file.name)
                if(idxNewVAl == -1){
                    if(file.path.id != undefined){
                        this.hapusSE.push(file.path.id)
                    }
                }
            }

            this.input.spesifikasi[idx].filePDF = this.pdfNewValSpek

             this.$bvModal.hide("modal-hapus-se-spek")
        },
    },
    // formulate-file-remove
    watch : {

        "pdf.urlPDF.files" : function(newVal){
            //Hapus SE
            if(this.pdfRecords.length > newVal.length){
                this.pdf.urlPDF.files = this.pdfRecords
                this.pdfNewVal = newVal
                this.$bvModal.show("modal-hapus-se")
            }
            //Tambah SE
            else {
            let pdf = []
            let i = 0
            for(var file of this.pdf.urlPDF.files){
                let name = file.name
             
                pdf.push(file)
            }
            this.input.filePDF = pdf
            this.pdfRecords = pdf
            }
            
        },

        "pdf.file.fileList" : function(newVal){
            let Pdfbase64 = []
            let i = 0
            for(var file of this.pdf.file.fileList){
                let name =file.name
              
                Pdfbase64.push(file)
            }
            this.input.filePDF = Pdfbase64
        },



        //Kondisi SE
        "pdf1.urlPDF.files" : function(newVal){
            //Hapus SE
            if(this.pdfRecords1.length > newVal.length){
                this.pdf1.urlPDF.files = this.pdfRecords1
                this.pdfNewVal1 = newVal
                this.$bvModal.show("modal-hapus-se-kel")
            }
            //Tambah SE
            else {
            let pdf = []
            let i = 0
            for(var file of this.pdf1.urlPDF.files){
                let name = file.name
              
                pdf.push(file)
            }
            this.input.filePDFKelengkapan = pdf
            this.pdfRecords1 = pdf
            }
            
        },

        "pdf1.file.fileList" : function(newVal){
            let Pdfbase64 = []
            let i = 0
            for(var file of this.pdf1.file.fileList){
                let name =file.name
                Pdfbase64.push(file)
            }
            this.input.filePDFKelengkapan = Pdfbase64
        },

        "url" : function(newVal){
        }
    },

    created(){
        this.init()
    },
}
</script>
